var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{class:{
    'cookie-consent-banner-button cookie-consent-banner-button--contained': !_vm.outline,
    'cookie-consent-banner-button cookie-consent-banner-button--outline': _vm.outline,
  },on:{"click":function($event){return _vm.$emit('click')}}},[_vm._v(" "+_vm._s(_vm.label)+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }